import CraftQL from '@/components/CraftQL'
import query from './query.gql'
import { get, pick } from 'lodash'

function transformEntry (entry) {
	const body = entry.body.map((block) => {
		switch(block.type) {
			case 'video':
				return {
					...block,
					video: {
						src: block.src,
						cc: block.cc
					}
				}
			case 'image':
				return {
					type: block.type,
					url: get(block, 'image[0].url')
				}
			default: return block
		}
	})
	const { blogAuthor, ...rest } = entry
	const author = (() => {
		if(blogAuthor) {
			return {
				title: get(blogAuthor, '[0].title'),
				headshot: get(blogAuthor, '[0].headshot[0].thumb')
			}
		}
		return null
	})()
	return {
		...rest,
		author,
		leadImage: get(entry, 'leadImage[0].url'),
		leadThumb: get(entry, 'leadImage[0].thumb'),
		body,
		category: get(entry, 'categories[0].title')
	}
}

async function getEntries (variables) {
	const response = await CraftQL.query({ query, variables })
	const result = get(response, 'data.entries')
	return result.map(transformEntry)
}

export default {
	props: {
		variables: {},
		render: Function
	},
	data: () => ({
		ready: false,
		entries: []
	}),
	async created () {
		this.entries = await getEntries(this.variables)
		this.ready = true
	},
	render () {
		const props = pick(this, ['ready', 'entries'])
		return this.render(props)
	}
}



// WEBPACK FOOTER //
// ./src/components/BlogishEntries/index.js